"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../../styles");

var _colors = require("../../styles/colors");

var backgroundColor = function backgroundColor(_ref) {
  var type = _ref.type;

  switch (type) {
    case 'darker':
      return _styles.colors.koala;

    case 'darkest':
      return _styles.colors.black;

    case 'light':
      return _styles.colors.white;

    case 'warning':
      return _colors.allDataVizColors.infrared;

    case 'error':
      return _styles.colors.cherryRed;

    default:
      return _styles.colors.sterling;
  }
};

var color = function color(_ref2) {
  var type = _ref2.type;

  switch (type) {
    case 'darker':
    case 'darkest':
    case 'warning':
    case 'error':
      return _styles.colors.white;

    default:
      return _styles.colors.black;
  }
};

var border = function border(_ref3) {
  var type = _ref3.type;

  switch (type) {
    case 'light':
      return "1px solid ".concat(_styles.colors.black);

    default:
      // Style functions that return `undefined` won't create a style property
      return undefined;
  }
};

var styles = {
  root: {
    display: 'inline-flex',
    fontSize: '10px',
    fontWeight: 500,
    letterSpacing: '1px',
    padding: '7px 10px',
    marginRight: '10px',
    textTransform: 'uppercase',
    backgroundColor: backgroundColor,
    color: color,
    border: border,
    borderRadius: '3px'
  }
};
var _default = styles;
exports["default"] = _default;